import React from 'react'
import DataCorrectionPage from '../dataCorrection/components/DataCorrectionPage'

// Route shell of the "Workday correction" screen (story 202, S4/S6). The page owns its own title and its two tabs
// (timelines and the history of corrections), so SmartNavigator is deliberately not used here.
const MainDataCorrection = () => <DataCorrectionPage />

export default MainDataCorrection
